import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import ScrollBar from "react-perfect-scrollbar";
import GetORPostAsync from '../constants/restservice';
import Swal from "sweetalert2";
import usericon from '../assets/images/users/2.png'
import '../assets/css/common.css';


export default function TicketReplies(props) {
    const navigate = useNavigate();
    let params = useParams();
    const [message, setMessage] = useState('');
    const [data, setData] = useState([]);
    useEffect(() => {
        new ScrollBar('.chat-content');
        GetTransactions();
    }, [])

    const GetTransactions = async () => {
        let res = await GetORPostAsync("support_reply_list.asp", "POST", JSON.stringify({ supportid: params.supportid }), localStorage.getItem("token"));
        if (res.status == "error") {
            if (res.message == "Session Expired") {
                navigate("/");
            }
            //toast(res.message);
            return;
        }
        setData(res.items);
    }
    const AddReply = async (e) => {
        e.preventDefault();
        if (!message) {
            toast('Enter message')
            return;
        }
        let response = await GetORPostAsync('support_reply.asp', 'POST', JSON.stringify({ supportid: params.supportid, reply: message }), localStorage.getItem("token"));
        if (response.status == 'error') {
            if (response.message == "Session Expired") {
                navigate("/");
            }
            toast(response.message);
            return;
        }
        toast(response.message);
        setMessage('');
        GetTransactions();
    }


    return (
        <div class="page-wrapper">
            <div class="page-content p-0">
                <div className='card-body' style={{ position: 'relative' }}>
                    <div style={{ height: '80vh', overflowY: 'scroll', paddingBottom: 60 }}>
                        {
                            data.map((item, index) => {
                                if (item.from != 'admin') {
                                    return <div class="chat-content-rightside" key={index}>
                                        <div class="d-flex ms-auto">
                                            <div class="flex-grow-1" style={{marginRight:10}}>
                                                <p class="mb-0 chat-time text-end">you, {item.Ctime}</p>
                                                <p class="chat-right-msg">{item.message}</p>
                                            </div>
                                        </div>
                                    </div>
                                } else {
                                    return <div class="chat-content-leftside" key={index}>
                                    <div class="d-flex">
                                        <img src={usericon} width="48" height="48" class="rounded-circle" alt="" />
                                        <div class="flex-grow-1 ms-2" style={{marginLeft:10}}>
                                            <p class="mb-0 chat-time-left">Admin, {item.Ctime}</p>
                                            <p class="chat-left-msg">{item.message}</p>
                                        </div>
                                    </div>
                                </div>
                                }
                              
                            })
                        }
                    </div>
                    <form class="card mb-0" style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }} onSubmit={AddReply}>
                        <div className='card-body d-flex align-items-center'>
                            <div class="flex-grow-1 pe-2">
                                <div class="input-group">
                                    <input type="text" onChange={(e) => setMessage(e.target.value)} value={message} class="form-control" placeholder="Type a message" />
                                </div>
                            </div>
                            <div class="chat-footer-menu">
                                <button type='submit' style={{ padding: 0, backgroundColor: 'transparent', border: 'none' }}><a> <i style={{color:'white'}} className="las la-paper-plane inputicon"></i></a></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
